document.addEventListener('click', function (event) {
  var button = event.target.closest('[data-bc-step]');
  if (!button || !button.closest('#cart-summary, #cartform')) return;
  event.preventDefault();
  var cart = button.closest('#cart-summary, #cartform');
  if (cart.classList.contains('updating')) return;
  var input = button.closest('.bc-cart-quantity').querySelector('input');
  var current = Number(input.value);
  if (!Number.isInteger(current) || current < 0) return;
  var next = Math.max(0, current + Number(button.dataset.bcStep));
  if (input.hasAttribute('data-bc-max')) next = Math.min(next, Number(input.dataset.bcMax));
  if (next === current) return;
  input.value = String(next);
  if (cart.id === 'cartform') {
    cart.classList.add('updating');
    cart.querySelectorAll('[data-bc-step]').forEach(function (control) { control.disabled = true; });
    cart.requestSubmit(cart.querySelector('#update-cart'));
    return;
  }
  input.dispatchEvent(new Event('change', { bubbles: true }));
});